import styled from 'styled-components';

export interface IGhostButton
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  displayIconRight?: boolean;
  isUnderlined?: boolean;
  className?: string;
}

type TButton = { displayIconRight?: boolean; isUnderlined?: boolean };
const Button = styled.button<TButton>`
  color: ${({ theme }) => theme.colors.GREY_DARK};
  height: ${({ theme }) => theme.spacing.M24};
  cursor: pointer;
  padding: 0;
  position: relative;
  display: flex;
  align-items: center;
  outline: none;

  ${({ theme, isUnderlined }) =>
    isUnderlined &&
    `
      &:hover,
      &:focus {
        &:after {
          background-color: ${theme.colors.GREY_DARK};
          position: absolute;
          bottom: -4px;
          left: 0;
          right: 0;
          content: '';
          width: 100%;
          height: 1px;
        }
      }
  `};

  /* The ghost button will be used a lot with icons and text. 
  Adding the text in a span will add default spacing */
  span {
    ${({ displayIconRight, theme }) =>
      displayIconRight
        ? `margin-right: ${theme.spacing.S4}`
        : `margin-left: ${theme.spacing.S4}`};
    color: ${({ theme }) => theme.colors.GREY_DARK};
  }

  &:disabled {
    color: ${({ theme }) => theme.colors.GREY_LIGHT};
    cursor: not-allowed;

    &:after {
      background-color: transparent;
    }

    span {
      color: ${({ theme }) => theme.colors.GREY_LIGHT};
    }

    svg {
      path {
        stroke: ${({ theme }) => theme.colors.GREY_LIGHT};
      }
    }
  }
`;

/**
 * These are buttons with most styles striped
 */
function GhostButton({
  children,
  className,
  displayIconRight,
  isUnderlined,
  ...rest
}: IGhostButton) {
  return (
    <Button
      className={className}
      displayIconRight={displayIconRight}
      isUnderlined={isUnderlined}
      {...rest}
    >
      {children}
    </Button>
  );
}

export { GhostButton };
